<template>
	<div class="chat-container">
		<div class="menuBox">
			<div class="menuTitle">
				消息列表
				<div class="allRead" @click="readAllStatus">全部已读</div>
			</div>
			<div class="naviBar">
				<div class="naviBarItem" :class="selNaviBar == 0 ? 'active' : 'normal'" @click="changeReadStatus(0)">
					全部({{readAll}})</div>
				<div class="naviBarItem" :class="selNaviBar == 1 ? 'active' : 'normal'" @click="changeReadStatus(1)">
					未读({{unRead}})</div>
			</div>
			<div class="chatList" v-if="chatList.length">
				<template v-for="(item,index) in chatList">
					<div class="person" :key="index"
						:class="item.type == 1 && item.id == curChat.id ? 'personSel' : 'personNor'"
						v-if="item.type == 1" @click="goToChat(item)">
						<div class="avatarBox">
							<img class="avatar" :src="item.avatar" v-if="item.avatar" />
							<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
							<div class="point" v-if="item.status == 2"></div>
						</div>
						<div class="nameTimeMsg">
							<div class="nameTime">
								<div class="name">{{item.nickname}}</div>
								<div class="time">{{item.time}}</div>
							</div>
							<div class="msg">
								<div class="msgTitle ellipsis-1">{{item.content}}</div>
								<img class="delete" src="../../assets/Chat/iconA.png" @click="deleteChat(item)" />
							</div>
						</div>
						<div class="line"></div>
					</div>
					<div class="group" :key="index"
						:class="item.type == 2 && item.id == curChat.id ? 'personSel' : 'personNor'"
						v-if="item.type == 2" @click="goToChat(item)">
						<div class="avatarBox">
							<img class="avatar" src="../../assets/Chat/iconE.png" />
							<div class="point" v-if="item.status == 2"></div>
						</div>
						<div class="nameTimeMsg">
							<div class="nameTime">
								<div class="name">{{item.title}}</div>
								<div class="time">{{item.time}}</div>
							</div>
							<div class="msg">
								<div class="msgTitle ellipsis-1">{{item.content}}</div>
								<img class="delete" src="../../assets/Chat/iconA.png" @click="deleteChat(item)" />
							</div>
						</div>
						<div class="line"></div>
					</div>
				</template>
			</div>
			<el-empty :image-size="50" description="暂无数据" v-else></el-empty>
			<div class="addGroupBox" @click="showCreate = true">
				<img class="addIcon" src="../../assets/Chat/iconF.png" />
				添加分组
			</div>
		</div>
		<div class="chatBox" v-if="curChat.id">
			<div class="chatTop" v-if="curChat.type == 1">
				<div class="chatTopLeft">
					<img class="avatar" :src="curChat.avatar" v-if="curChat.avatar" />
					<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
					<div class="name">
						{{curChat.nickname ? curChat.nickname : ''}}
					</div>
				</div>
			</div>
			<div class="chatTop" v-if="curChat.type == 2">
				<div class="chatTopLeft">
					<img class="avatar" src="../../assets/Chat/iconE.png" />
					<div class="name">
						{{curChat.title}}（{{curChat.user_count}}）
					</div>
				</div>
				<div class="groupPeople" @click="inGroupFansShow = true">
					<img class="groupImg" src="../../assets/Chat/iconB.png" />
					群成员
				</div>
			</div>
			<div class="chatContent" ref="msgList">
				<template v-for="(item,index) in recordData">
					<div class="chatItem" :key="index" style="justify-content: flex-start"
						v-if="item.user_id != userId">
						<div class="left">
							<div class="name">
								{{item.user && item.user.user_nickname ? item.user.user_nickname : '' }}
							</div>
							<div class="avatarMsg">
								<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
								<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
								<div class="msgContent" v-html="item.content.replace(/\n/g, '<br/>')"
									v-if="item.status == 1">
								</div>
								<div class="msgContent" v-if="item.status == 2">
									<el-image class="imgItem" :src="item.img" fit="cover" :preview-src-list="[item.img]"
										@load="loadImgSuc">
									</el-image>
								</div>
							</div>
							<div class="time">
								{{item.create_time}}
							</div>
						</div>
					</div>
					<div class="chatItem" :key="index" style="justify-content: flex-end;" v-if="item.user_id == userId">
						<div class="right">
							<div class="name">
								{{item.user && item.user.user_nickname ? item.user.user_nickname : '' }}
							</div>
							<div class="avatarMsg">
								<div class="msgContent" v-html="item.content.replace(/\n/g, '<br/>')"
									v-if="item.status == 1">
								</div>
								<div class="msgContent" v-if="item.status == 2">
									<el-image class="imgItem" :src="item.img" fit="cover" :preview-src-list="[item.img]"
										@load="loadImgSuc">
									</el-image>
								</div>
								<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
								<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
							</div>
							<div class="time">
								{{item.create_time}}
							</div>
						</div>
					</div>
				</template>
			</div>
			<div class="chatOperation">
				<div class="emojiPicture">
					<img class="emojiPictureItem" src="../../assets/Chat/iconC.png" @click.stop="toggleEmoji" />
					<img class="emojiPictureItem" src="../../assets/Chat/iconD.png"
						@click="$refs.upload.$el.querySelector('input').click()" />
					<EmojiPicker ref="emojiPanel" :visible.sync="showEmoji" @select="onEmojiSelect" />
				</div>
				<div class="inputBox">
					<textarea v-model="content" cols="30" rows="10"></textarea>
					<div class="send" @click="sendMsg">发送</div>
				</div>
			</div>
		</div>
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<CreateChatStepOneDialog :show="showCreate" @close="showCreate = false" @update="createGroup" />
		<GroupFansDialog :show="showCreateTwo" :data="groupInfo" @createSuc="createSuc"
			@close="showCreate = $event;showCreateTwo = false;" @createFailsThree="createFailsThree" />
		<InGroupFansDialog :show="inGroupFansShow" :gid="curChat.mb_id" @close="inGroupFansShow = false"
			@nextStep="tipPop = true" @addFans="addFansToGroupShow = true" />
		<AddFansToGroupDialog :show="addFansToGroupShow" :gid="curChat.mb_id"
			@close="addFansToGroupShow = false;inGroupFansShow = false;" @addFansSuc="addFansSuc" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'确定解散群组？'" :descTwo="'确定后群组将被解散不可撤销'"
			:btnTitle="'解散群组'" @clickOk="confirmDissolveGroup" v-if="tipPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'当前已有3个群'" :descTwo="'请解散后再创建'"
			@clickOk="createdFailPop = false" v-if="createdFailPop" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="desc" @clickOk="sucPop = false;"
			v-if="sucPop" />
	</div>
</template>

<script>
	import EmojiPicker from "../../components/EmojiPicker.vue"
	import GroupFansDialog from '../../components/GroupFansDialog.vue'
	import InGroupFansDialog from '../../components/InGroupFansDialog.vue'
	import AddFansToGroupDialog from '../../components/AddFansToGroupDialog.vue'
	import CreateChatStepOneDialog from '../../components/CreateChatStepOneDialog.vue'
	export default {
		name: 'ChatList',
		components: {
			EmojiPicker,
			GroupFansDialog,
			InGroupFansDialog,
			AddFansToGroupDialog,
			CreateChatStepOneDialog
		},
		data() {
			return {
				showEmoji: false,
				listTimer: null,
				msgTimer: null,
				desc: '',
				sucPop: false,
				tipPop: false,
				createdFailPop: false,
				curChat: {},
				content: '',
				chatList: [],
				groupInfo: {},
				recordData: [],
				selNaviBar: 0,
				unRead: 0,
				readAll: 0,
				showCreate: false,
				showCreateTwo: false,
				inGroupFansShow: false,
				addFansToGroupShow: false,
				userId: localStorage.getItem('userId'),
			}
		},
		created() {
			if (this.$route.query.userId) {
				if (this.$route.query.type) {
					this.getChatList(true)
				} else {
					this.userGreent()
				}
			} else {
				this.getChatList(false)
			}
			this.listTimer = setInterval(() => {
				this.getChatList(false)
			}, 5000);
			// this.addGroupUser()
			// this.creatGroupChat()
		},
		mounted() {
			document.addEventListener("click", this.handleClickOutside);
		},
		beforeDestroy() {
			document.removeEventListener("click", this.handleClickOutside);
			if (this.msgTimer) {
				clearInterval(this.msgTimer);
			}
			if (this.listTimer) {
				clearInterval(this.listTimer);
			}
		},
		methods: {
			handleClickOutside() {
				const panel = this.$refs.emojiPanel;
				if (this.showEmoji && panel) {
					this.showEmoji = false;
				}
			},
			toggleEmoji() {
				this.showEmoji = !this.showEmoji;
			},
			onEmojiSelect(e) {
				this.content += e; // 直接插入
			},
			userGreent() {
				this.$api.post('/Liaotian/user_greet', {
					mb_id: this.$route.query.userId,
				}).then(res => {
					if (res.code == 1) {
						this.getChatList(true)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			readAllStatus() {
				this.$api.post('/Liaotian/lt_show', {}).then(res => {
					if (res.code == 1) {
						this.getChatList(false)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeReadStatus(index) {
				this.selNaviBar = index
				this.getChatList(false)
			},
			loadImgSuc() {
				this.$nextTick(() => {
					const div = this.$refs.msgList;
					div.scrollTop = div.scrollHeight;
				});
			},
			//发送图片
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.$api.post('/Liaotian/lt_add', {
					type: this.curChat.type == 1 ? 2 : 1,
					mb_id: this.curChat.mb_id,
					content: response.data,
					status: 2,
				}).then(res => {
					if (res.code == 1) {
						this.messageList()
						this.content = ''
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//解散群组
			confirmDissolveGroup() {
				this.tipPop = false
				this.$api.post('/Liaotian/del_group', {
					gid: this.curChat.mb_id
				}).then(res => {
					if (res.code == 1) {
						this.desc = '群组解散成功'
						this.sucPop = true
						this.curChat = {}
						this.getChatList(false)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//删除聊天记录
			deleteChat(item) {
				this.$confirm('确认删除当前聊天吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Liaotian/lt_hide', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.desc = '删除成功！'
							this.sucPop = true
							this.curChat = {}
							this.getChatList(false)
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			//添加成员成功
			addFansSuc() {
				this.inGroupFansShow = false
				this.desc = '添加成功'
				this.sucPop = true
				this.getChatList(false)
			},
			//创建群组成功
			createSuc() {
				this.desc = '创建成功'
				this.showCreate = false
				this.showCreateTwo = false
				this.sucPop = true
				this.getChatList(false)
			},
			//创建超过三个群
			createFailsThree() {
				this.showCreate = false
				this.showCreateTwo = false
				this.createdFailPop = true
			},
			createGroup(data) {
				this.groupInfo = {
					...data
				}
				this.showCreateTwo = true
			},
			nextStep() {
				this.showCreateTwo = false
			},
			creatGroupChat() {
				this.$api.post('/Hua/create_group', {
					title: '分组1',
					content: '测试分组1',
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			sendMsg() {
				if (!this.content) return
				this.$api.post('/Liaotian/lt_add', {
					type: this.curChat.type == 1 ? 2 : 1,
					mb_id: this.curChat.mb_id,
					content: this.content,
					status: 1,
				}).then(res => {
					if (res.code == 1) {
						this.messageList()
						this.content = ''
					}
				}).catch(err => {
					console.log(err);
				})
			},
			addGroupUser() {
				this.$api.post('/Hua/add_group_user', {
					user_id: '12814',
					gid: 5,
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			goToChat(item) {
				this.curChat = item
				this.messageList()
				clearInterval(this.msgTimer);
				if (!this.msgTimer) {
					this.msgTimer = setInterval(() => {
						this.messageList()
					}, 5000);
				}
			},
			getChatList(isFirst) {
				this.$api.post('/Liaotian/message_list', {
					type: this.selNaviBar == 0 ? '' : 1, //1未读  不传是全部
				}).then(res => {
					if (res.code == 1) {
						this.readAll = res.data.all_count
						this.unRead = res.data.wd_count
						this.chatList = res.data.list
						if (isFirst && this.chatList.length) {
							if (this.chatList.findIndex(item => item.mb_id == this.$route.query.userId) > -1) {
								this.goToChat(this.chatList.find(item => item.mb_id == this.$route.query.userId))
							}
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			messageList() {
				this.$api.post('/Liaotian/lt_list', {
					id: this.curChat.id,
				}).then(res => {
					if (res.code == 1) {
						this.recordData = res.data
						this.$nextTick(() => {
							const div = this.$refs.msgList;
							div.scrollTop = div.scrollHeight;
						});
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.chat-container {
		margin: .24rem .24rem;
		display: flex;
		background: #FFFFFF;
		border-radius: .08rem;
		height: calc(100vh - 3.66rem);
	}

	.menuBox {
		width: 2.68rem;
		height: 100%;
		display: flex;
		flex-direction: column;
		// padding: .24rem 0 .24rem .16rem;
		position: relative;

		.menuTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 600;
			font-size: .16rem;
			color: #000000;
			margin: .24rem .16rem .2rem;

			.allRead {
				font-weight: 400;
				font-size: .12rem;
				color: #E29358;
				cursor: pointer;
			}
		}

		.naviBar {
			margin: 0 auto;
			display: flex;
			align-items: center;
			width: 2.18rem;
			height: .28rem;
			border-radius: .06rem;
			border: .01rem solid #CCCCCC;
			overflow: hidden;

			.naviBarItem {
				width: 50%;
				height: .28rem;
				line-height: .28rem;
				font-weight: 400;
				font-size: .12rem;
				text-align: center;
				cursor: pointer;
			}

			.active {
				color: #FFFFFF;
				background: #6B3503;
			}

			.normal {
				color: #333333;
				background: #FFFFFF;
			}
		}

		.addGroupBox {
			position: absolute;
			bottom: .24rem;
			left: calc(50% - .4rem);
			width: .8rem;
			height: .3rem;
			border-radius: .04rem;
			border: .01rem solid #E29358;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 400;
			font-size: .12rem;
			color: #E29358;
			cursor: pointer;

			.addIcon {
				margin-right: .04rem;
				width: .12rem;
				height: .12rem;
			}
		}

		.chatList::-webkit-scrollbar {
			width: .08rem;
		}

		// /* Firefox */
		// .chatList {
		// 	scrollbar-width: none;
		// 	/* Firefox 隐藏滚动条 */
		// }

		// /* IE / Edge 老版本 */
		// .chatList {
		// 	-ms-overflow-style: none;
		// 	/* IE11, Edge */
		// }

		.chatList {
			margin-top: .04rem;
			width: 100%;
			display: flex;
			flex-direction: column;
			height: calc(100vh - 5.3rem);
			overflow-y: auto;

			.personNor {
				background: #FFFFFF;
			}

			.personSel {
				background: rgba(226, 147, 88, .1);
			}

			.person,
			.group {
				flex-shrink: 0;
				width: 100%;
				padding: 0 .16rem;
				height: .66rem;
				display: flex;
				align-items: center;
				padding-bottom: .08rem;
				cursor: pointer;
				position: relative;

				.line {
					position: absolute;
					bottom: 0;
					left: .16rem;
					width: calc(100% - .32rem);
					border-bottom: .01rem solid #CCCCCC;
				}

				.avatarBox {
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;

					.avatar {
						width: .34rem;
						height: .34rem;
						overflow: hidden;
						object-fit: cover;
						border-radius: 50%;
					}

					.point {
						position: absolute;
						top: 0;
						right: 0;
						width: .1rem;
						height: .1rem;
						border-radius: 50%;
						background: #FF0000;
						border: .01rem solid #FFFFFF;
					}
				}

				.nameTimeMsg {
					margin-top: .02rem;
					margin-left: .12rem;
					width: 1.9rem;
					display: flex;
					flex-direction: column;

					.nameTime {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.name {
							font-weight: 400;
							font-size: .14rem;
							color: #252525;
						}

						.time {
							font-weight: 400;
							font-size: .12rem;
							color: #999999;
						}
					}

					.msg {
						display: flex;
						align-items: center;
						justify-content: space-between;
						font-weight: 500;
						font-size: .12rem;
						color: #252525;

						.msgTitle {
							flex: 1;
							min-width: 0;
						}

						.delete {
							width: .14rem;
							height: .14rem;
							flex-shrink: 0;
						}
					}
				}
			}
		}
	}

	.chatBox {
		width: calc(100% - 2.68rem);
		background: #FAFAFA;

		.chatTop {
			height: .54rem;
			padding: 0 .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #FFFFFF;

			.chatTopLeft {
				display: flex;
				align-items: center;

				.avatar {
					width: .3rem;
					height: .3rem;
					overflow: hidden;
					object-fit: cover;
					border-radius: 50%;
				}

				.name {
					margin-left: .08rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
				}
			}

			.groupPeople {
				width: .68rem;
				height: .3rem;
				border-radius: .04rem;
				border: .01rem solid #E29358;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .12rem;
				color: #E29358;
				cursor: pointer;

				.groupImg {
					margin-right: .02rem;
					width: .14rem;
					height: .14rem;
				}
			}
		}

		.chatContent::-webkit-scrollbar {
			width: 0;
			height: 0;
		}

		.chatContent {
			scrollbar-width: none;
		}

		.chatContent {
			-ms-overflow-style: none;
		}

		.chatContent {
			height: calc(100vh - 5.64rem);
			display: flex;
			flex-direction: column;
			overflow-y: auto;

			.chatItem {
				display: flex;
				align-items: center;
				margin-top: .16rem;
			}

			.right {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.name {
					margin-right: .8rem;
					font-weight: 400;
					font-size: .12rem;
					color: #666666;
				}

				.avatarMsg {
					margin-top: .04rem;
					display: flex;
					align-items: flex-start;

					.avatar {
						margin-right: .32rem;
						width: .35rem;
						height: .35rem;
						overflow: hidden;
						object-fit: cover;
						border-radius: 50%;
					}

					.msgContent {
						margin-right: .16rem;
						max-width: 4.4rem;
						background: #E29358;
						padding: .16rem .16rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						border-radius: .05rem;
					}
				}

				.time {
					margin-top: .08rem;
					margin-right: .8rem;
					font-weight: 400;
					font-size: .12rem;
					color: #666666;
				}
			}

			.left {
				display: flex;
				flex-direction: column;

				.name {
					margin-left: .8rem;
					font-weight: 400;
					font-size: .12rem;
					color: #666666;
				}

				.avatarMsg {
					margin-top: .04rem;
					display: flex;
					align-items: flex-start;

					.avatar {
						margin-left: .32rem;
						width: .35rem;
						height: .35rem;
						overflow: hidden;
						object-fit: cover;
						border-radius: 50%;
					}

					.msgContent {
						margin-left: .16rem;
						max-width: 4.4rem;
						background: #FFFFFF;
						padding: .16rem .16rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						border-radius: .05rem;

						.msgImg {
							max-width: 4.4rem;
							height: auto;
							object-fit: cover;
						}
					}
				}

				.time {
					margin-top: .08rem;
					margin-left: .8rem;
					font-weight: 400;
					font-size: .12rem;
					color: #666666;
				}
			}
		}

		.chatOperation {
			height: 1.44rem;
			display: flex;
			flex-direction: column;
			padding: .16rem .24rem .16rem .32rem;
			background: #FFFFFF;

			.emojiPicture {
				display: flex;
				align-items: center;
				position: relative;

				.emojiPictureItem {
					width: .2rem;
					height: .2rem;
					margin-right: .1rem;
					cursor: pointer;
				}
			}

			.inputBox {
				margin-top: .12rem;
				height: .8rem;
				position: relative;

				textarea {
					width: 100%;
					height: .8rem;
					background: #FAFAFA;
					padding: 0.08rem 0.08rem;
					border: none;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					cursor: pointer;
				}

				.send {
					position: absolute;
					right: 0;
					bottom: 0;
					width: .68rem;
					height: .36rem;
					background: #E29358;
					border-radius: .04rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					line-height: .36rem;
					text-align: center;
					cursor: pointer;
				}

			}
		}
	}
</style>